module.exports = __webpack_public_path__ + "img/administration.f1f4d279.svg";